<template>
  <div class="vue-video">
    <div class="vue-video-box">
      <Carousel
        ref="carouselRef"
        v-model="currentSlide"
        :breakpoints="breakpoints"
        @slideEnd="slideEnd"
      >
        <Slide
          v-for="(card, index) in list"
          :key="index"
          class="slideEl"
        >
          <VideoCard
            v-if="isVideo"
            :card="card as MediaFile"
            class="carousel__slide"
          />
          <RecentCard
            v-else
            :card="card as LabData"
            class="carousel__slide"
          />
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>

    <CarouselPagination
      ref="paginationRef"
      :carouselRef="carouselRef"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import { LabData } from '@/types/LabData';
import RecentCard from '@/components/Carousel/RecentCard.vue';
import VideoCard from '@/components/Carousel/VideoCard.vue';
import { MediaFile } from '@/types/manuals';
import CarouselPagination from '@/components/Carousel/CarouselPagination.vue';

defineProps<{
  list: LabData[] | MediaFile[];
  isVideo?: boolean;
}>();

const currentSlide = ref(0);
const carouselRef = ref();
const paginationRef = ref();
const breakpoints = ref();

onMounted(() => {
  breakpoints.value = {
    // 320 and up
    320: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 1.25 : 1,
      snapAlign: 'start',
    },
    480: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 2.25 : 2,
      snapAlign: 'start',
    },
    961: {
      itemsToShow: 3,
      snapAlign: 'start',
    },
  };
});

const slideEnd = () => {
  paginationRef.value.updVisibleCards();
};
</script>

<style lang="scss">
@import "@/assets/style/include";
.vue-video {

  .carousel__next {
    inset-inline-end: -5%;
  }
  .carousel__prev {
    inset-inline-start: -5%;
  }

  .is-dragging {
    pointer-events: none;
  }

  &-box {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }

  &__next {
    transform: rotate(180deg);

  }

  .carousel__pagination-button {
    padding: 10px;
  }
}

.carousel__slide:has(.recent-card) {
  min-height: 112px;
}

@include media-breakpoint-down("tablet") {
  .vue-video {

    .carousel {
      width: 100%;
    }

    .pagination,
    .carousel__next,
    .carousel__prev {
      display: none;
    }
  }
}
@include media-breakpoint-down("mobile") {
  .vue-video {

    .carousel {
      width: 100%;
    }
  }
}
</style>
